<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 fxHide.sm fxHide.md fxHide.lg fxHide.xl>
                {{ t("application.tab.personal-info") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/personal-info-icon.svg"
                        alt="personal-info-icon"
                    />
                    <h2>{{ t("application.personal-info.header") }}</h2>
                    <p
                        class="title"
                        *ngIf="client$ | async as client"
                        [innerHTML]="client.personalInfoHtml"
                    ></p>
                    <p class="subtitle">
                        {{ t("application.personal-info.sub-title") }}
                    </p>
                    <app-personal-information-form
                        [fields]="fields$ | async"
                        [value]="formValue$ | async"
                        (submitted)="onSubmitted($event)"
                    ></app-personal-information-form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined" style="box-shadow: none">
                    <h2>{{ t("application.summary-card.header") }}</h2>
                    <p class="small">
                        {{ t("application.summary-card.title") }}
                    </p>
                    <div *ngFor="let provider of selectedProviders">
                        <p class="title">
                            {{ provider.providerName }}
                        </p>
                        <ul>
                            <li *ngFor="let program of provider.programs">
                                {{ program }}
                            </li>
                        </ul>
                        <ul>
                            <li *ngFor="let address of provider.addresses">
                                {{ address }}
                            </li>
                        </ul>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</ng-container>
